var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeResponseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 145 145",
    fill: "white",
    fillOpacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5003 105.096C90.5028 105.096 105.097 90.5025 105.097 72.5001C105.097 54.4977 90.5028 39.9038 72.5003 39.9038C54.4979 39.9038 39.9041 54.4977 39.9041 72.5001C39.9041 90.5025 54.4979 105.096 72.5003 105.096ZM112.766 72.5001C112.766 94.7384 94.7386 112.766 72.5003 112.766C50.2621 112.766 32.2344 94.7384 32.2344 72.5001C32.2344 50.2618 50.2621 32.2341 72.5003 32.2341C94.7386 32.2341 112.766 50.2618 112.766 72.5001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5724 89.8616C61.7495 91.05 60.119 91.3463 58.9306 90.5235C57.7422 89.7006 57.4459 88.0701 58.2688 86.8817C61.9034 81.6325 66.8323 78.915 72.8256 78.915C78.8706 78.915 83.6366 81.6881 86.8271 87.0295C87.5684 88.2705 87.1633 89.8774 85.9223 90.6186C84.6813 91.3599 83.0744 90.9548 82.3332 89.7138C80.0767 85.9361 77.0063 84.1496 72.8256 84.1496C68.5931 84.1496 65.252 85.9917 62.5724 89.8616Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.608,
    cy: 66.1074,
    r: 5.41695
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.6095,
    cy: 66.1074,
    r: 5.41695
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 127,
    textAnchor: "middle",
    fontSize: 20,
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif"
  }, "\n        Ineffective\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeResponseButton);
export default __webpack_public_path__ + "static/media/Negative Response Button.1a98bdbddfd05abe167635e5119ef985.svg";
export { ForwardRef as ReactComponent };